module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.e0e78cb6.jpg";